<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_re3"
      :custom="{storage: true}"
      export
      :refresh="{query: RefreshList}"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('carRepairReview_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('carRepairReview_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      highlight-hover-row
      highlight-current-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column>
        <vxe-table-column
          field="repairType"
          title="维修类型"
          min-width="130"
          sortable
        >
          <template v-slot="{ row }">
            {{ repairTypeMap[row.repairType] }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.repairType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="(v,k) in repairTypeMap"
              :key="k"
              :value="k"
              :label="v"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="numberPlate"
          title="车牌号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.numberPlate"
            placeholder="请输入车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="title"
          title="申请内容"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.title"
            placeholder="请输入申请内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="审核状态"
          min-width="130"
          sortable
        >
          <template v-slot="{ row }">
            {{ auditMap[row.status] }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.status"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="(v,k) in auditMap"
              :key="k"
              :value="k"
              :label="v"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="isReportComplete"
          title="上报维修"
          min-width="130"
          sortable
        >
          <template v-slot="{ row }">
            {{ isReportCompleteMap[row.isReportComplete] }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.isReportComplete"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="(v,k) in isReportCompleteMap"
              :key="k"
              :value="k"
              :label="v"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column

        title="操作"
        fixed="right"
        min-width="100"
      >
        <template v-slot="{row}">
          <el-tooltip
            v-if="getLimit('carRepairReview_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDetail(row.code)"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('carRepairReview_audit_button') && row.status=='0' && (isAdmin || row.applyStatus=='0')"
            class="item"
            effect="dark"
            content="审核"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcAudit(row.code,row.step)"
            >
              <i class="el-icon-s-check" />
            </vxe-button>
          </el-tooltip>


          <el-tooltip
            v-else-if="getLimit('carRepairReview_auditInfo_button') && row.status != '0' || (isAdmin || row.applyStatus!='0') "
            class="item"
            effect="dark"
            content="审核信息"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcAudit(row.code,-1)"
            >
              <i class="el-icon-tickets" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="800"
      height="600"
      resize
    >
      <compDetail ref="detailRef" />
    </vxe-modal>
    <vxe-modal
      v-model="modelAuditFlag"
      title="审核"
      width="640"
      height="600"
      resize
    >
      <compAudit
        ref="auditRef"
        :process-type="processType"
        :process-api="processApi"
        @fatherAuditMethod="fatherAudit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compDetail from "./components/vehicleRepairApplyDetail.vue";
import compAudit from "@/views/tms/review/audit.vue";
import request from "@/utils/request";
export default {
  name: "VehicleRepairApplyList",
  components: {
    compDetail,
    compAudit
  },
  data() {
    return {
      exportObj:{
        exportUrl:"/ntocc-basic-api/vehicleRepairApply/exportReviewList",//导出接口
        name:'维修审核'
      },
      auditMap: {
        "0": "待审核",
        "1": "已通过",
        "2": "已拒绝"
      },
      isReportCompleteMap:{
         "0": "否",
         "1": "是"
      },
      repairTypeMap: {
        "0": "中途坏车",
        "1": "内部车辆",
        "2": "外出维修"
      },
      processType: "1",
      processApi: "ntocc-basic-api/vehicleRepairApply",
      modelAuditFlag: false,
      modelDetailFlag: false,
      message: "",
      loading: false,
      tableData: [],
      copy: false,
      listQuery: {
        code: "",
        branchCode: "",
        repairType: "",
        numberPlate: "",
        title: "",
        details: "",
        images: "",
        reviewerRoleCode: "",
        reviewerCode: "",
        status: "",
        step: "",
        reviewerTime: "",
        isOutingRepair: "",
        outingRepairFactory: "",
        outingRepairMan: "",
        outingRepairPhone: "",
        outingRepairDetails: "",
        outingRepairImgs: "",
        isReportComplete: "",
        reportCompleteFee: "",
        reportCompleteDetails: "",
        reportCompleteImgs: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
    };
  },
  created() {
    this.findList();
    const partyType = this.$store.getters.party.partyType
    this.isAdmin = partyType == 'PLAT_ADMIN';

  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: `/ntocc-basic-api/vehicleRepairApply/page4Review`,
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 详情方法
    funcDetail(code) {
      this.$refs.detailRef.getInfo(code);
      this.modelDetailFlag = true;
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "audit":
          this.modelAuditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    },
    // 审核方法
    funcAudit(code, step) {
      this.$refs.auditRef.getInfo(code, step);
      this.modelAuditFlag = true;
    },
    // 审核组件的父方法
    fatherAudit() {
      this.modelAuditFlag = false;
      this.findList();
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
